import { PromiseStatus, PromiseStatusEnum } from "../../core/PromiseStatus";
import { useCallback, useState } from "react";

const useTrackPromise = <CallableT extends (...args) => Promise<any> = () => Promise<any>>(callable: CallableT, initial?: Awaited<ReturnType<CallableT>>): [CallableT, Awaited<ReturnType<CallableT>> | undefined, PromiseStatus] => {
    const [state, setState] = useState<{ status: PromiseStatusEnum, data?: Awaited<ReturnType<CallableT>> }>({
        status: PromiseStatusEnum.INITIALIZED,
        data: initial
    });

    //@ts-ignore
    const wrapper: CallableT = useCallback((...args) => {
        setState(state => ({ status: PromiseStatusEnum.PENDING, data: state.data }));
        return callable(...args)
            .then(
                value => {
                    setState({ status: PromiseStatusEnum.SUCCEEDED, data: value });
                    return value;
                },
                error => {
                    if (error) {
                        setState(state => ({ status: PromiseStatusEnum.FAILED, data: state.data }));
                    }
                    throw error;
                }
            )
            .catch(error => {
                if (error) {
                    setState(state => ({ status: PromiseStatusEnum.FAILED, data: state.data }));
                }
                throw error;
            }) as ReturnType<CallableT>;
    }, [])

    return [wrapper, state.data, new PromiseStatus(state.status)];
}
export default useTrackPromise;